<div class="w-100 row">
  <div class="col-sm-12 col-md-6 col-lg-3">
    <h4>{{ 'content.activity' | translate }}</h4>
    <div>{{ 'content.report-date' | translate }}: {{ reformatDate(det.recordDate) }}</div>
    <div>{{ 'content.last-payment-date' | translate }}: {{ reformatDate(det.lastPaymentDate) }}</div>
    <div>{{ 'content.last-sale-date' | translate }}: {{ reformatDate(det.lastSaleDate) }}</div>
    <div>{{ 'content.secured' | translate }}: {{ det.tradeAcntSecured }}</div>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-3">
    <h4>{{ 'content.status-and-balance' | translate }}</h4>
    <div>{{ 'content.account-status' | translate }}: {{ det.tradeAcntStatusType }}</div>
    <div>{{ 'content.annual-sales' | translate }}: {{ i18nService.formatCurrency(det.annualSales) | async }}</div>
    <div>{{ 'content.credit-limit' | translate }}: {{ i18nService.formatCurrency(det.creditLimit) | async }}</div>
    <div>{{ 'content.high-balance' | translate }}: {{ i18nService.formatCurrency(det.highBalance) | async }}</div>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-6">
    <h4>{{ 'content.terms-and-history' | translate }}</h4>
    <div>{{ 'content.terms' | translate }}: {{ getPaymentTerms() }}</div>
    <div>{{ 'content.recent-payment-history' | translate }}: {{ getRecentPaymentHistory() }}</div>
    <div>{{ 'content.past-payment-history' | translate }}: {{ getPastPaymentHistory() }}</div>
    <div>{{ 'content.returned-cheques' | translate }}: {{ det.nsfCheques }}</div>
  </div>
</div>
<hr/>
<div class="w-100 row pt-2">
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.total-owing' | translate }}</h4>
    <div>{{ getTotalOwing() | async }}</div>
  </div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.future' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.futureReceivables) | async }}</div>
  </div>
  <div class="w-100 d-block d-md-none"></div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.due-current' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.dueCurrent) | async }}</div>
  </div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.1st-overdue' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.due30) | async }}</div>
  </div>
  <div class="w-100 d-block d-lg-none"></div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.2nd-overdue' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.due60) | async }}</div>
  </div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.3rd-overdue' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.due90) | async }}</div>
  </div>
  <div class="w-100 d-block d-md-none"></div>
  <div class="col pdf-reactor-7">
    <h4>{{ 'content.4th-overdue' | translate }}</h4>
    <div>{{ i18nService.formatCurrency(det.due120) | async }}</div>
  </div>
</div>
<hr/>
<div class="w-100 pt-2"><strong>{{ 'content.suppliers-comments' | translate }}</strong>: {{ det.tradeDetComment }}</div>
